import styled from 'styled-components';
import { ZIndex } from '@optimus-web/common';

export interface TargetWrapperElementProps {
    disablePointerEvents?: boolean;
}

export const TargetWrapperElement = styled.div<TargetWrapperElementProps>`
    z-index: ${ZIndex.Highest};
    ${(props) => props.disablePointerEvents && 'pointer-events: none;'}
`;
